import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=52f0d86c"
import script from "./patient.vue?vue&type=script&lang=js"
export * from "./patient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f0d86c')) {
      api.createRecord('52f0d86c', component.options)
    } else {
      api.reload('52f0d86c', component.options)
    }
    module.hot.accept("./patient.vue?vue&type=template&id=52f0d86c", function () {
      api.rerender('52f0d86c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personnel/patient.vue"
export default component.exports